export type App = 'ease' | 'wavon';
export type Platform = 'ios' | 'android';
export type DeployTarget = 'backend' | 'admin_panel';

export interface AppRelease {
  id: number;
  app: App;
  platform: Platform;
  version: string;
  released_at: string | null;
  /** False when inferred from git (e.g. old Android versions), not seen in a store. */
  date_confirmed: boolean;
  build_number: string;
  /** False = assumed to be the newest build of the version; stores don't say. */
  build_confirmed: boolean;
  commit_sha: string;
  branch: string;
  summary: string;
  store_notes: string;
  source: string;
  updated_at: string;
  /** The version customers get from the store today. */
  is_live: boolean;
}

export interface AppBuild {
  id: number;
  app: App;
  platform: Platform;
  version: string;
  build_number: string;
  built_at: string | null;
  commit_sha: string;
  branch: string;
  on_main: boolean | null;
  workflow: string;
  source: string;
  status: 'live' | 'released' | 'testing' | 'superseded';
}

export interface Deployment {
  id: number;
  target: DeployTarget;
  external_id: string;
  deployed_at: string;
  commit_sha: string;
  branch: string;
  on_main: boolean | null;
  deployed_by: string;
  summary: string;
  source: string;
  /** The newest deploy of its target: what's running now. */
  is_live: boolean;
}

export interface DeploymentListModel {
  count: number;
  next: string | null;
  previous: string | null;
  results: Deployment[];
}

export interface UnreleasedFeature {
  id: number;
  title: string;
  is_active: boolean;
  created_at: string;
}

export const APP_LABELS: Record<App, string> = { ease: 'Ease', wavon: 'Wavon' };
export const PLATFORM_LABELS: Record<Platform, string> = { ios: 'iPhone', android: 'Android' };
export const TARGET_LABELS: Record<DeployTarget, string> = { backend: 'Server', admin_panel: 'Admin panel' };
export const APP_COLORS: Record<App, string> = { ease: '#0a9775', wavon: '#ccac8c' };
